import { getSessionVariable } from '@services/storage';

import { MarketingsState, StoredMarketings } from '@hooks/use-marketings';

import { MarketingType } from '@constants/plan';

export function getMarketings(
    defaultMarketings: MarketingsState = {
        [MarketingType.HOME]: true,
    },
): MarketingsState {
    const newMarketingPlan: MarketingsState = { ...defaultMarketings };

    const storedMarketings = JSON.parse(getSessionVariable('promoConfigurator') ?? '{}') as StoredMarketings;

    if (storedMarketings) {
        if (storedMarketings.home !== undefined) {
            newMarketingPlan[MarketingType.HOME] = storedMarketings.home;
        }
    }

    return newMarketingPlan;
}
